var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "tender-general" } }, [
    _c(
      "form",
      { attrs: { id: "general-form", "data-abide": "", novalidate: "" } },
      [
        _c("div", { staticClass: "row align-justify general-info" }, [
          _c(
            "div",
            { staticClass: "medium-8 large-8 columns" },
            [
              _c("TextField", {
                attrs: {
                  id: "modules-tenders-edit-general-projectDescription",
                  metaData: _vm.fieldMetaData.projectDescription,
                  readonly: false,
                  required: true,
                },
              }),
              _vm._v(" "),
              _c("TextField", {
                attrs: {
                  id: "modules-tenders-edit-general-projectLocation",
                  metaData: _vm.fieldMetaData.projectLocation,
                  readonly: false,
                  required: true,
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "tender-label emphasis" }, [
                _c("label", { staticClass: "required-flag" }, [
                  _vm._v(_vm._s(_vm.$t("tender.general.projectStart")) + ": "),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row align-middle" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: (_vm.fieldMetaData.projectStart || {}).value,
                        expression: "(fieldMetaData.projectStart || {}).value",
                        modifiers: { number: true },
                      },
                      { name: "hkldinput", rawName: "v-hkldinput" },
                      {
                        name: "fusioninputcheck",
                        rawName: "v-fusioninputcheck",
                        value: { type: "integer" },
                        expression: "{type: 'integer'}",
                      },
                    ],
                    staticClass:
                      "small-2 medium-2 large-2 num_input validity-period zero-margin-left",
                    attrs: {
                      id: "modules-tenders-edit-general-projectStart",
                      type: "text",
                      name: "projectStart",
                      novalidate: "",
                      required: true,
                    },
                    domProps: {
                      value: (_vm.fieldMetaData.projectStart || {}).value,
                    },
                    on: {
                      change: function (event) {
                        return _vm.updateFieldValue(
                          "projectStart",
                          event.target.value
                        )
                      },
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.fieldMetaData.projectStart || {},
                          "value",
                          _vm._n($event.target.value)
                        )
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "validity-period-label" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.projectStartLabel) +
                        "\n            "
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("TextField", {
                attrs: {
                  id: "modules-tenders-edit-general-estimatedProjectDuration",
                  metaData: _vm.fieldMetaData.estimatedProjectDuration,
                  readonly: false,
                  required: true,
                },
              }),
              _vm._v(" "),
              _vm.closingDate && _vm.closingDate.value
                ? _c(
                    "div",
                    { staticClass: "row closing-date-extension" },
                    [
                      _c("TextField", {
                        staticClass: "small-6 medium-6 large-6",
                        attrs: {
                          id: "modules-tenders-edit-general-closingDate",
                          metaData: _vm.closingDate,
                          readonly: true,
                          required: true,
                        },
                      }),
                      _vm._v(" "),
                      _vm.closingDateExtended
                        ? _c(
                            "label",
                            { staticClass: "closing-date-extension-label" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("tender.extensionRequested")) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", [
                        _vm.closingDateExtended &&
                        _vm.isAddendum &&
                        _vm.isPicView
                          ? _c("a", {
                              staticClass:
                                "fa fa-undo closing-date-extension-undo",
                              attrs: { "aria-hidden": "true" },
                              on: {
                                click: function ($event) {
                                  return _vm.undoClosingDateExtension()
                                },
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.closingDateExtended &&
                        _vm.isAddendum &&
                        _vm.isPicView
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn--orange closing-date-extension-btn",
                                on: {
                                  click: function ($event) {
                                    return _vm.updateFieldValue(
                                      "closingDateExtended",
                                      true
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("tender.extendClosingDate")) +
                                    "\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { id: "tender.general.workingHours" } },
                [
                  _c("working-hours", {
                    attrs: { metaData: _vm.fieldMetaData.workingHours },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "tender-label emphasis noisyWorkingHour-section",
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.noisyWorkingHoursChecked,
                        expression: "noisyWorkingHoursChecked",
                      },
                      { name: "hkldinput", rawName: "v-hkldinput" },
                    ],
                    staticClass: "general-checkbox",
                    attrs: {
                      id: "tender.general.noisyWorkingHours",
                      type: "checkbox",
                      name: "noisyWorkingHours",
                    },
                    domProps: {
                      checked: Array.isArray(_vm.noisyWorkingHoursChecked)
                        ? _vm._i(_vm.noisyWorkingHoursChecked, null) > -1
                        : _vm.noisyWorkingHoursChecked,
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$a = _vm.noisyWorkingHoursChecked,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.noisyWorkingHoursChecked = $$a.concat([
                                  $$v,
                                ]))
                            } else {
                              $$i > -1 &&
                                (_vm.noisyWorkingHoursChecked = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.noisyWorkingHoursChecked = $$c
                          }
                        },
                        function (event) {
                          return _vm.onNoisyWorkingHourChecked(
                            "noisyWorkingHoursChecked",
                            event
                          )
                        },
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "noisy-working-hours",
                      attrs: { for: "tender.general.noisyWorkingHours" },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("tender.general.noisyWorkingHours")) +
                          "\n          "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.noisyWorkingHoursChecked
                ? _c(
                    "div",
                    { attrs: { id: "tender.general.noisyWorkingHours" } },
                    [
                      _c("working-hours", {
                        attrs: {
                          isMandatory: _vm.noisyWorkingHoursChecked,
                          emptyWorkingHours: _vm.emptyNoisyWorkingHours,
                          metaData: _vm.fieldMetaData.noisyWorkingHours,
                          hideLabel: true,
                        },
                        on: {
                          "reset:emptyWorkingHours": function ($event) {
                            _vm.emptyNoisyWorkingHours = false
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("TextField", {
                attrs: {
                  id: "modules-tenders-edit-general-specialWorkingHours",
                  metaData: _vm.fieldMetaData.specialWorkingHours,
                  readonly: false,
                  required: false,
                },
              }),
              _vm._v(" "),
              _c("TextField", {
                attrs: {
                  id: "modules-tenders-edit-general-paymentTerms",
                  metaData: _vm.fieldMetaData.paymentTerms,
                  readonly: false,
                  required: false,
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "tender-label emphasis" }, [
                _c("label", { staticClass: "required-flag" }, [
                  _vm._v(
                    _vm._s(_vm.$t("tender.general.validityPeriod")) + ": "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row align-middle" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.number",
                        value: _vm.validityPeriod,
                        expression: "validityPeriod",
                        modifiers: { number: true },
                      },
                      { name: "hkldinput", rawName: "v-hkldinput" },
                      {
                        name: "fusioninputcheck",
                        rawName: "v-fusioninputcheck",
                        value: { type: "integer" },
                        expression: "{type: 'integer'}",
                      },
                    ],
                    staticClass:
                      "small-2 medium-2 large-2 num_input validity-period zero-margin-left",
                    attrs: {
                      id: "modules-tenders-edit-general-validityPeriod",
                      type: "text",
                      name: "validityPeriod",
                      required: "",
                    },
                    domProps: { value: _vm.validityPeriod },
                    on: {
                      change: function (event) {
                        return _vm.updateFieldValue(
                          "validityPeriod",
                          event.target.value
                        )
                      },
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.validityPeriod = _vm._n($event.target.value)
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "validity-period-label" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$i18n.t("tender.general.validityPeriodLabel")
                        ) +
                        "\n            "
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tender-label emphasis" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.onsiteVisitRequired,
                      expression: "onsiteVisitRequired",
                    },
                    { name: "hkldinput", rawName: "v-hkldinput" },
                  ],
                  staticClass: "general-checkbox",
                  attrs: {
                    id: "tender.general.onsiteVisitRequired",
                    type: "checkbox",
                    disabled: _vm.isAddendum && !_vm.closingDateExtended,
                    name: "onsiteVisitRequired",
                  },
                  domProps: {
                    checked: Array.isArray(_vm.onsiteVisitRequired)
                      ? _vm._i(_vm.onsiteVisitRequired, null) > -1
                      : _vm.onsiteVisitRequired,
                  },
                  on: {
                    change: [
                      function ($event) {
                        var $$a = _vm.onsiteVisitRequired,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_vm.onsiteVisitRequired = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.onsiteVisitRequired = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.onsiteVisitRequired = $$c
                        }
                      },
                      function (event) {
                        return _vm.onsiteVisitRequiredChanged(
                          event.target.checked
                        )
                      },
                    ],
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "onsite-visit",
                    attrs: { for: "tender.general.onsiteVisitRequired" },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("tender.general.onsiteVisitRequired")) +
                        "\n          "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "tender-label emphasis" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.optionalItemsChecked,
                      expression: "optionalItemsChecked",
                    },
                    { name: "hkldinput", rawName: "v-hkldinput" },
                  ],
                  staticClass: "general-checkbox",
                  attrs: {
                    id: "tender.general.optionalItems",
                    type: "checkbox",
                    name: "optionalItems",
                  },
                  domProps: {
                    checked: Array.isArray(_vm.optionalItemsChecked)
                      ? _vm._i(_vm.optionalItemsChecked, null) > -1
                      : _vm.optionalItemsChecked,
                  },
                  on: {
                    change: [
                      function ($event) {
                        var $$a = _vm.optionalItemsChecked,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_vm.optionalItemsChecked = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.optionalItemsChecked = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.optionalItemsChecked = $$c
                        }
                      },
                      function (event) {
                        return _vm.updateOptionalItemChecked(
                          event.target.checked
                        )
                      },
                    ],
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "optional-checkbox",
                    attrs: { for: "tender.general.optionalItems" },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("tender.general.optionalItems")) +
                        ":\n          "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm.optionalItemsChecked
                ? _vm._l(_vm.optionalItems, function (item, index) {
                    return _c("div", { key: index }, [
                      _c(
                        "div",
                        { staticClass: "row align-middle optional-items" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "small-1 middle-1 large-1 optional-items-checkbox",
                            },
                            [
                              _c("input", {
                                directives: [
                                  { name: "hkldinput", rawName: "v-hkldinput" },
                                ],
                                attrs: {
                                  id: item.name,
                                  type: "checkbox",
                                  name: item.name + " Required",
                                },
                                domProps: { checked: item.selected },
                                on: {
                                  change: function (event) {
                                    return _vm.onOptionalItemCheckBoxChanged(
                                      index,
                                      event.target.checked
                                    )
                                  },
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            { staticClass: "small-4 middle-4 large-4 columns" },
                            [_vm._v(_vm._s(item.name))]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "small-2 middle-2 large-2 columns" },
                            [
                              _c("input", {
                                directives: [
                                  { name: "hkldinput", rawName: "v-hkldinput" },
                                  {
                                    name: "fusioninputcheck",
                                    rawName: "v-fusioninputcheck",
                                    value: _vm.getCheckRule(item),
                                    expression: "getCheckRule(item)",
                                  },
                                ],
                                staticClass:
                                  "num_input no-padding-right-columns",
                                class: {
                                  "error-highlight":
                                    _vm.noItemSelected ||
                                    _vm.invalidOptionalItems[index],
                                },
                                attrs: {
                                  id: item.name,
                                  type: "text",
                                  name: item.name,
                                  disabled: !item.selected,
                                },
                                domProps: { value: item.value },
                                on: {
                                  change: function (event) {
                                    return _vm.onOptionalItemValueChanged(
                                      index,
                                      event.target.value
                                    )
                                  },
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            { staticClass: "small-4 middle-4 large-4 columns" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.defaultOptionalItems[index].text.trim()
                                )
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isTender
                ? [
                    _c("div", { staticClass: "tender-label emphasis" }, [
                      _c("label", { staticClass: "required-flag" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("tender.general.conditionsOfContracts.label")
                          ) + ": "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.isSiteLoaded && _vm.cocI18nValue
                      ? _c(
                          "div",
                          {
                            ref: "conditionsOfContracts",
                            staticClass: "tender-conditions-of-contracts",
                          },
                          [
                            _vm._l(_vm.cocI18nValue, function (value, key) {
                              return _c(
                                "div",
                                {
                                  key: "cocI18n_" + key,
                                  staticClass: "row align-middle coc-items",
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "small-1 middle-1 large-1 coc-items-checkbox",
                                    },
                                    [
                                      _c("input", {
                                        attrs: {
                                          id: "coc-input-" + key,
                                          type: "radio",
                                          name: "tender.general.conditionsOfContracts",
                                        },
                                        domProps: {
                                          value: _vm._f("uppercase")(key),
                                          checked:
                                            _vm.checkConditionOfContracts(key),
                                        },
                                        on: {
                                          click: function (event) {
                                            return _vm.onConditionsOfContractsChanged(
                                              key
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("label", {
                                    staticClass:
                                      "small-11 middle-11 large-11 columns",
                                    attrs: { for: "coc-input-" + key },
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.getCocItemByType(key)
                                      ),
                                    },
                                  }),
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _vm.cocFileRequired
                              ? _c(
                                  "label",
                                  {
                                    staticClass:
                                      "small-11 middle-11 large-11 columns coc-items",
                                  },
                                  [
                                    _c("i", { staticClass: "reminder" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "tender.general.conditionsOfContracts.minFilesHint"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.cocFileRequired
                              ? _c("FileUpload", {
                                  ref: "cocStandardAttachmentFileUpload",
                                  attrs: {
                                    attachment: _vm.cocStandardAttachment,
                                    resourceId: _vm.general.id,
                                    metaData: {
                                      category:
                                        "" + _vm.TENDER_CONDITIONS_OF_CONTRACTS,
                                    },
                                    minFiles: 1,
                                  },
                                  on: {
                                    "update:attachment": function ($event) {
                                      _vm.cocStandardAttachment = $event
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "medium-4 large-4 columns general-view-tab-right" },
            [
              _c("div", { staticClass: "tender-label emphasis" }, [
                _c("label", { staticClass: "prNumber-label" }, [
                  _vm._v(_vm._s(_vm.$t("tender.general.prNumber")) + ":"),
                ]),
              ]),
              _vm._v(" "),
              _vm.isAddendum || !_vm.isPicView
                ? _c("div", [
                    _c(
                      "p",
                      {
                        attrs: { id: "modules-tenders-edit-general-prNumber" },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.fieldMetaData.prNumber.value) +
                            "\n          "
                        ),
                      ]
                    ),
                  ])
                : _c(
                    "div",
                    {
                      staticClass:
                        "row align-left align-middle pr-number-edit-margin",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "small-6 middle-6 large-4 columns" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.prNumber,
                                expression: "prNumber",
                              },
                              {
                                name: "fusioninputcheck",
                                rawName: "v-fusioninputcheck",
                                value: {
                                  type: "integer",
                                  required: _vm.prNumber,
                                },
                                expression:
                                  "{type: 'integer', required: prNumber}",
                              },
                            ],
                            staticClass: "add-prNumber zero-margin-left",
                            attrs: {
                              id: "tender-general-prNumber",
                              type: "text",
                              name: "prNumber",
                              "data-validator": "validatePrNo",
                            },
                            domProps: { value: _vm.prNumber },
                            on: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.addPRNo()
                              },
                              change: _vm.handlePrNoUpdate,
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.prNumber = $event.target.value
                              },
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn--darkblue btn-add",
                          attrs: {
                            id: "modules-tenders-edit-general-pr-add",
                            role: "add-button",
                            name: "addPrNo",
                            type: "button",
                            disabled: _vm.disablePrNumber,
                          },
                          on: { click: _vm.addPRNo },
                        },
                        [_vm._v(_vm._s(_vm.$t("action.add")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.general.prNumber && !_vm.isAddendum,
                              expression: "general.prNumber && !isAddendum",
                            },
                          ],
                          staticClass: "btn btn--darkblue btn-remove",
                          attrs: {
                            id: "modules-tenders-edit-general-pr-remove",
                            role: "remove-pr-button",
                            name: "removePR",
                            type: "button",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.removeContractData()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("action.removePR")))]
                      ),
                    ]
                  ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pr-info", attrs: { id: "pr-window" } },
                [
                  _c("div", { staticClass: "tender-label emphasis" }, [
                    _c("label", { attrs: { for: "tender.general.budget" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("tender.general.estimatedBudget")) + ":"
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "span",
                      {
                        staticClass: "pr-data",
                        attrs: { id: "tender.general.budget" },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm._f("formatCurrency")(_vm.budget, {
                                currencyCode: _vm.currencyCode,
                              })
                            ) +
                            "\n            "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("TextField", {
                    attrs: {
                      id: "modules-tenders-edit-general-creator",
                      metaData: _vm.fieldMetaData.creator,
                      readonly: true,
                    },
                  }),
                  _vm._v(" "),
                  _c("TextField", {
                    attrs: {
                      id: "modules-tenders-edit-general-manager",
                      metaData: _vm.fieldMetaData.manager,
                      readonly: true,
                    },
                  }),
                  _vm._v(" "),
                  _c("TextField", {
                    attrs: {
                      id: "modules-tenders-edit-general-site",
                      metaData: _vm.site,
                      readonly: true,
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "tender-label emphasis pr-info" }, [
                    _c(
                      "label",
                      { attrs: { for: "tender.general.invitedVendors" } },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("tender.general.vendors")) +
                            " (" +
                            _vm._s(
                              _vm.bids ? Object.entries(_vm.bids).length : "-"
                            ) +
                            "):"
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "vendor-list" },
                    _vm._l(_vm.bids, function (bid) {
                      return _c("li", { key: bid.id }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.deep(bid, "company.name") || "") +
                            "\n            "
                        ),
                      ])
                    }),
                    0
                  ),
                ],
                1
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("ContractData", {
          ref: "contractDialog",
          attrs: { contractData: _vm.contractData },
          on: {
            "update:contractData": function ($event) {
              _vm.contractData = $event
            },
            "update:contract-data": function ($event) {
              _vm.contractData = $event
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }